import Lucide from '@/components/Base/Lucide'
import { Business } from '@/config';
import { renderTime } from '@/helper';
import { useTrackingTimer } from '@/components/hooks/useTrackingTimer';

interface ListTimeProps {
    order: any,
    shop: Business
}

export default function ListTime({ order, shop }: ListTimeProps) {
    const timeText = useTrackingTimer(order?.statusTracking?.pending);

    return (
        <div className={`${renderTime(timeText, shop.performanceConfig.maxServiceTime)}`}>
            <div className="flex gap-1 items-center text-[12px] font-semibold">
                <Lucide icon="AlarmClock" className="w-4 pb-0.5 stroke-[2]" />
                {timeText}
            </div>
        </div>
    )
}
